<template>
	<div
		class="p-d-flex p-flex-column p-flex-md-row p-text-left p-justify-center p-grid"
	>
		<Accordion class="p-col-12" :multple="false" :activeIndex="active">
			<AccordionTab>
				<template #header>
					<div class="p-d-flex p-justify-between" style="width: 100%">
						<p class="p-my-0">
							{{ store.ChildInfo["child" + childNumber].firstName }}
							{{ store.ChildInfo["child" + childNumber].lastName }}
						</p>
					</div>
				</template>

				<div class="p-mt-2">
					<p class="p-text-bold p-text-center">Program Permission:</p>
					<p class="p-text-light p-mt-2">
						Throughout programming your child may participate in field trips and
						neighbourhood outings arranged by Girls Inc. of Durham and be
						transported by vehicle or walking, with adult supervision.
					</p>
					<p class="p-text-light p-mt-2">
						During the year Girls Inc. of Durham may connect with your family
						through phone calls, chalking etc. to check in. Your medical
						coverage is the primary insurer for your child and will not hold
						Girls Inc. of Durham responsible in the case of an accident or
						injury.*
					</p>
					<div
						v-for="option of programPermissionOptions"
						:key="option.key"
						class="p-field-radiobutton p-my-2"
					>
						<RadioButton
							:id="'program' + option.key + childNumber"
							name="option"
							:value="option"
							v-model="programPermission"
						/>

						<label
							:for="'program' + option.key + childNumber"
							class="p-text-bold"
							>{{ option.name }}</label
						>
					</div>

					<small
						v-if="v$.programPermission.$invalid && submitted"
						class="p-error"
					>
						{{
							v$.programPermission.required.$message.replace("Value", "Option")
						}}
					</small>
				</div>

				<div class="p-mt-3">
					<p class="p-text-bold p-text-center">Media Release:</p>
					<p class="p-text-light p-mt-2">
						There may be occasions where pictures of your child will be taken -
						these photos might be used for newsletting, videos, brochures,
						annual reports, radio, television, newspapers and our website or
						Girls Inc National.*
					</p>
					<div
						v-for="option of mediaReleaseOptions"
						:key="option.key"
						class="p-field-radiobutton p-my-2"
					>
						<RadioButton
							:id="'media' + option.key + childNumber"
							name="option"
							:value="option"
							v-model="mediaReleasePermission"
						/>
						<label
							:for="'media' + option.key + childNumber"
							class="p-ml-1 p-text-bold"
							>{{ option.name }}</label
						>
					</div>

					<small
						v-if="v$.mediaReleasePermission.$invalid && submitted"
						class="p-error"
					>
						{{
							v$.mediaReleasePermission.required.$message.replace(
								"Value",
								"Option"
							)
						}}
					</small>
				</div>

				<!-- <p style="width: 100%" class="p-text-center">
					<small
						v-if="v$.childTotalAmount.$invalid && submitted"
						class="p-error"
					>
						{{
							v$.childTotalAmount.minValue.$message.replace(
								"The minimum value allowed is 1",
								"Please select a Program before continuing"
							)
						}}
					</small>
				</p> -->
			</AccordionTab>
		</Accordion>
	</div>
</template>

<script>
import { useFormDataStore } from "../../store/formData.js";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
	name: "ChildWaiver",
	data() {
		return {
			active: 0,
			submitted: false,
			// filteredItems: [],
			programPermissionOptions: [
				{
					name: "I give permission for my child to participate in Girls Inc. of Durham's programming",
					key: "Yes",
				},
				{
					name: "I do NOT give permission for my child to participate in Girls Inc. of Durham's programming",
					key: "No",
				},
			],
			programPermission: null,
			mediaReleaseOptions: [
				{
					name: "I give permission for my child and/or myself to appear in any Girls Inc. of Durham publications",
					key: "Yes",
				},
				{
					name: "I do NOT give permission for my child and/or myself to appear in any Girls Inc. of Durham publications",
					key: "No",
				},
			],
			mediaReleasePermission: null,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			v$: useVuelidate(),
			store,
		};
	},
	validations() {
		return {
			programPermission: { required },
			mediaReleasePermission: { required },
		};
	},
	props: {
		childNumber: Number,
		validateForm: Number,
		validateAllChildrenInfoForms: Function,
	},
	watch: {
		async validateForm() {
			const isFormValid = await this.v$.$validate();
			this.submitted = true;

			if (!isFormValid) {
				this.validateAllChildrenInfoForms(false, this.childNumber);
			} else {
				const childWaiverData = {
					programPermission: this.programPermission,
					mediaReleasePermission: this.mediaReleasePermission,
				};
				Object.assign(
					this.store.ChildInfo["child" + this.childNumber],
					childWaiverData
				);
				this.validateAllChildrenInfoForms(true, this.childNumber);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.field-radiobutton label {
	cursor: pointer;
}
</style>
